import DisplayCurrencyOrPrizeSuffix from '../DisplayPrizeCurrencyOrSuffix/DisplayPrizeCurrencyOrSuffix';
import { filterOutUndefinedValues } from '../../common/arrayUtils';
import { Event, Selection } from '../../interfaces/sports';
import { Entry, Pick } from '../../interfaces/predictors';

export const getPrizeText = ({
  t,
  prize,
  currencyCode,
  prizeCode,
  prizeMultiplier,
}: {
  t: (str: string) => string;
  prize: number;
  currencyCode: string;
  prizeCode?: string;
  prizeMultiplier?: number;
}) => {
  const translationKeyMap: Record<string, string> = {
    betcredit: 'prize-board-bet-credit-prize',
    freespin: 'history-modal-freespin-won',
  };

  const translationKey = translationKeyMap[prizeCode ?? ''] || 'history-modal-won';

  return (
    <span>
      <span>+</span>
      <DisplayCurrencyOrPrizeSuffix
        value={prize}
        currency={currencyCode}
        suffix={translationKey}
        prizeCode={prizeCode}
        prizeMultiplier={prizeMultiplier}
      />
    </span>
  );
};

export interface GameSelection {
  event: Event;
  selection: Selection;
  replaced?: Selection;
  countryCode?: string;
}

const mapSelectionCode = ({ pick, event }: { pick: Pick; event: Event }) =>
  event.markets
    .find((market) => market.marketId === pick.marketId)
    ?.selections.find((selection) => selection.selectionCode === pick.selectionCode);

export const getSelections = (entry: Entry, events: Event[]): GameSelection[] => {
  return filterOutUndefinedValues(
    entry.picks
      .filter((p) => p.active)
      .map((pick) => {
        const event = events.find((event) => event.eventId === pick.eventId);
        if (event === undefined) return undefined;
        const nonRunner = entry.picks.find((p) => p.eventNumber === pick.eventNumber && p.active === false);
        const nonRunnerSelection = nonRunner ? mapSelectionCode({ pick: nonRunner, event }) : undefined;
        const selection = mapSelectionCode({ pick, event });
        if (selection === undefined) return undefined;
        return {
          event,
          selection: nonRunnerSelection ? nonRunnerSelection : selection,
          replaced: nonRunnerSelection ? selection : undefined,
          countryCode: entry?.countryCode,
        };
      }),
  );
};
